import React from 'react';
import icStar from 'assets/img/star.svg';
import icTrophy from 'assets/img/trophy.svg';
import icDiamond from 'assets/img/diamond.svg';
import icThumb from 'assets/img/thumb.svg';
import { EarnedRewardDto } from '@peartherapeutics/hylia-api-client';
import moment from 'moment';
import styles from './styles.module.scss';

interface ITable {
  rewards: EarnedRewardDto[];
  isInAppCm: boolean;
}

const Table = ({ rewards, isInAppCm }: ITable) => {
  // TODO: (JB) IS THIS STILL VALID? NEW REWARDTYPE VALUES DON'T MATCH.
  const renderRewardIcon = (reward: EarnedRewardDto) => {
    switch (reward.type.toLowerCase()) {
      case 'star':
        return (
          <img
            src={icStar}
            alt="reward-star"
            className={styles['reward-icon']}
          />
        );
      case 'trophy':
        return (
          <img
            src={icTrophy}
            alt="reward-troply"
            className={styles['reward-icon']}
          />
        );
      case 'diamond':
        return (
          <img
            src={icDiamond}
            alt="reward-diamond"
            className={styles['reward-icon']}
          />
        );
      case 'thumb':
        return (
          <img
            src={icThumb}
            alt="reward-thumb"
            className={styles['reward-icon']}
          />
        );
      default:
        return null;
    }
  };
  return (
    <div className={styles.container} data-testid="rewards-table">
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.header}>Date Earned</th>
            <th className={styles.header}>Reward Type</th>
            <th className={styles.header}>
              {isInAppCm ? 'Reward Amount' : 'Virtual Reward'}
            </th>
          </tr>
        </thead>
        <tbody>
          {rewards
            .sort((a, b) => Number(new Date(b.date)) - Number(new Date(a.date)))
            .map((reward: EarnedRewardDto, idx: number) => {
              const date = moment(reward.date).format('l');
              const key = `reward-${reward.date}-${Math.random() * 10}`;

              return (
                <tr className={styles.row} key={key}>
                  <td>{date}</td>
                  <td>{reward.type}</td>
                  <td>
                    <div className={styles['reward-amount-container']}>
                      {renderRewardIcon(reward)}
                      <span className={styles['reward-amount']}>
                        {isInAppCm && reward?.amount !== '$0'
                          ? reward.amount
                          : 'Virtual Reward'}
                      </span>
                    </div>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
